import ProductGroupingPartialsTitle from "./ProductGroupingPartialsTitle.component";

export default ProductGroupingPartialsTitle;
